// Reads the admin JWT saved by NavaService.login() and returns the
// Authorization header expected by every protected /api/... route.
export default function authHeader() {
  const raw = localStorage.getItem("user");
  if (!raw) return {};

  try {
    const stored = JSON.parse(raw);
    if (stored?.accessToken) {
      return { Authorization: "Bearer " + stored.accessToken };
    }
  } catch (e) {
    // corrupted localStorage entry, treat as logged out
  }
  return {};
}